module.exports = __WEBPACK_EXTERNAL_MODULE_chart_js_1c0615aa__;